//importer les feuille de styles
import './assets/styles/core.scss';

//import dependencies
import $ from "jquery";
window.$ = window.jQuery = $;
import "bootstrap";

//Importation des components
import "./components/index";